import { KeyValue as NovaKeyValue, styled } from '@fme-nova/components'
import React, { ReactNode } from 'react'

import { createComponentWrapperWithRef, MUI_PALETTE } from '../../theme'
import { Typography } from '../Typography'

export interface KeyValueBaseProps {
  label?: string
  direction?: 'row' | 'column'
  reverse?: boolean
  unit?: string
  size?: 'small' | 'medium'
  divider?: boolean
}

export type KeyValueProps =
  | (KeyValueBaseProps & {
      loading: true
      children?: ReactNode
    })
  | (KeyValueBaseProps & {
      loading?: false
      children: ReactNode
    })

function LegacyKeyValue({ label, children }: KeyValueProps) {
  const ItemContainer = styled('div')`
    gap: 8px;
    width: fit-content;
    display: flex;
    align-items: center;
  `

  return (
    <ItemContainer>
      <Typography color={MUI_PALETTE.text.secondary} variant="body1">
        {label}
      </Typography>
      <Typography color={MUI_PALETTE.text.primary} variant="body1">
        {children}
      </Typography>
    </ItemContainer>
  )
}

export const KeyValue = createComponentWrapperWithRef<KeyValueProps>(
  {
    mui: LegacyKeyValue,
    nova: NovaKeyValue,
  },

  'KeyValue',
)
